<template>
	<div class="tab" data-name="familiarInfo" data-type="table">
		<h3>فرم معرف</h3>
		<p>[درصورت آشنایي با هریك از کارکنان شرکت مشخصات آنان را به شرح ذیل اعلام فرمائيد]</p>
		<table class="table table-bordered">
			<thead>
				<tr>
					<td>نام و نام خانوادگی</td>
					<td>شغل</td>
					<td>نسبت</td>
					<td>مدت اشنایی</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="familiarName" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="familiarJob" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="ratio" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="familiarDuration" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="familiarName" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="familiarJob" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="ratio" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="familiarDuration" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},
		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		},



	}
</script>
